import React, { Component } from 'react';

import './Button.css';

class EditArea extends Component {

  constructor(props){
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount(){

  }

  handleClick(e){
    const target = e.target;
    target.classList.add('clicked');
    this.props.onClick();

    setTimeout(function () {
      target.classList.remove('clicked');
    }, 500);
  }

  render() {

    return (
      <div className="btn" onClick={this.handleClick}>{this.props.text}</div>
    );
  }
}

export default EditArea;

// EditArea.propTypes = {
//   text: React.PropTypes.string.isRequired
// }



// WEBPACK FOOTER //
// ./src/Button.js